// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Setting, Toss, Note, Line, Hexagram } = initSchema(schema);

export {
  Setting,
  Toss,
  Note,
  Line,
  Hexagram
};